import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Checkbox,
  FormControlLabel,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import { connect } from "react-redux";
import {
  START_GET_IMPORT_CSV_LIST,
  START_DELETE_MULTIPLE_AND_SINGLE_CSV,
  RESET_PATIENT_STATE,
} from "../../Actions/PatientAction";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import moment from "moment";
import { getClearObject } from "../../utils/generalUtils";
import { ReactComponent as EditIcon } from "../../Assets/Icons/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/DeleteIcon.svg";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import { ReactComponent as Info } from "../../Assets/Icons/info.svg";
import ImportExtraDataDiloag from "./ImportExtraDataDiloag";
import clsx from "clsx";
import useViewport from "../../Hooks/useViewport";
import { useSelector } from "react-redux";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import { importType } from "../../utils/data";
import ImportTypeDialog from "./ImportTypeDialog";
import { BorderColor, BorderStyle } from "@mui/icons-material";
const ConfirmationDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ConfirmationDialog")
);
const PatientCreateDialog = React.lazy(() => import("./PatientCreateDialog"));
const ImportCsvPatientDialog = React.lazy(() =>
  import("../../Components/ImportCsv/ImportCsvPatientDialog")
);

const useStyle = makeStyles((theme) => ({
  rsPatientHeader: {
    justifyContent: "end",
    "&>button": {
      height: "37px !important",
      marginLeft: "20px",
      [theme.breakpoints.down("906")]: {
        marginTop: "10px",
        marginLeft: "10px",
        marginRight: "10px",
      },
    },
    "&>div": {
      height: "37px !important",
      width: "200px",
      marginTop: "-1px",
      [theme.breakpoints.down("896")]: {
        marginTop: "10px",
        marginLeft: "10px",
      },
    },
  },
  rsButtonAddIcon: {
    [theme.breakpoints.down("906")]: {
      marginLeft: "20px",
    },
  },
  iconBtn: {
    marginTop: "3px !important",
    borderRadius: "10% !important",
  },
  tableBody: {
    "&>tr": {
      "&>td": {},
    },
  },
  rsPatientFCount: {
    backgroundColor: " #333",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    padding: " 6px 6px",

    // marginBottom: "20px",
    // display: "flex",
    // justifyContent: "end",
    "&>button": {
      marginLeft: "20px",
    },
  },
  iconBtn: {
    marginTop: "0px !important",
    borderRadius: "10% !important",
  },
  managePageH: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(99vh - 140px) !important",
      // padding: "13px !important",
      [theme.breakpoints.down(1400)]: {
        maxHeight: "calc(96vh - 200px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
      },
    },
  },
  managePageHMob: {
    "& .MuiTableContainer-root": {
      // padding: "13px !important",
      [theme.breakpoints.down("1200")]: {
        maxHeight: " !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
      },
    },
  },
  rsSelectMenulist: {
    position: "absolute !important",
    marginLeft: "-154px !important",
    width: "150px !important",
    opacity: "0 !important",
  },
  MenuListDownload: {
    borderColor: "#7BC044 !important",
    borderStyle: "solid !important",
    backgroundColor: "rgba(234, 251, 227, 1) !important",
    borderWidth: "2px !important",
    margin: "5px 20px !important",
    textAlign: "center !important",
    justifyContent: "center !important",
  },
}));

const ImportCsvMain = (props) => {
  const {
    getImportCsvListAction,
    importCsvListData,
    deleteCsvAction,
    deleteMultipleAndSingleCsvData,
    resetPatientState,
  } = props;
  const classes = useStyle();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const patientListRecordLimit = 20;
  const [openImportCsvPopup, setOpenImportCsvPopup] = useState(false);
  const [openCreatePatientPopup, setOpenCreatePatientPopup] = useState(false);
  const [createNewPatientFromCSV, setCreateNewPatientFromCSV] = useState("");
  const [deleteCsvData, setDeleteCsvData] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selected, setSelected] = React.useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [extraDataDiloag, setExtraDataDiloag] = useState(false);
  const [extraData, setExtraData] = useState([]);
  const [subscriptionDialog, setSubscriptionDialog] = useState(false);
  const width = useViewport();
  const { loginUserDetail } = useSelector((state) => state.user);
  const [importTypeDiloag, setImportTypeDiloag] = useState(false);
  const [docLink, setDocLink] = useState("");
  const [deleteRecordActionType, setDeleteRecordActionType] =
    React.useState("");
  /** Get patient api main function */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      q: searchValue,
      limit: patientListRecordLimit,
    };
    payload = {
      ...payload,
      ...params,
    };
    getImportCsvListAction(getClearObject(payload));
  };

  const handleDeleteCsvList = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscriptionDialog(true);
    // } else {
    let payload = {
      id:
        deleteRecordActionType === "singleRecordDelete" ? [deleteId] : selected,
      is_delete_all: selected?.length === importCsvListData?.data?.list?.length,
    };
    deleteCsvAction(payload);
    // }
  };

  const onSuccessOfSubmitPatientForm = () => {
    setOpenImportCsvPopup(false);
    getList();
  };

  useEffect(() => {
    getList();
  }, []);

  /** Pagination useEffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        importCsvListData?.data?.list?.length !=
        importCsvListData?.data?.filterd_record
      ) {
        getList({
          offset: importCsvListData?.data?.list?.length,
          limit: patientListRecordLimit,
        });
      }
    }
  }, [entry]);

  /** Delete Patient loading useEffect */
  useEffect(() => {
    if (
      !deleteMultipleAndSingleCsvData?.loading &&
      Object.keys(deleteMultipleAndSingleCsvData?.data)?.length
    ) {
      setDeleteCsvData(false);
      setDeleteId("");
      resetPatientState("deleteMultipleAndSingleCsvData", "");
      setSelected([]);
    }
  }, [deleteMultipleAndSingleCsvData]);

  /* Handle Change Action */
  const handleChangeAction = (e) => {
    if (e.target.checked) {
      const newSelected = importCsvListData?.data?.list?.map(
        (item) => item?.tp_id
      );
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  /* Handle Click Tick Action */
  const handleClickTickAction = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  /** Search debounce useref */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );
  /** Handle Search Funcation */
  const handleSearch = (newValue) => {
    let payLoad = {};
    searchUserDebounce.current(newValue, {});
  };
  /* Download csv demo file */
  const downloadPDF = () => {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/patients_new.csv",
      "patients.csv"
    );
  };

  return (
    <>
      <Grid>
        <Grid className={classes.rsPatientFCount}>
          <Grid className={classes.rsPatientHeader}>
            <TextField
              withPadding={true}
              medium
              secondary
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e?.target?.value);
                handleSearch(e?.target?.value);
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <PrimaryIcon width="20px" icon={SearchIcon} />
                    </InputAdornment>
                  </>
                ),
              }}
            />
            <Button
              className={clsx("BtnGreen", classes.rsButtonAddIcon)}
              variant="contained"
              onClick={() => {
                setDeleteRecordActionType("multipleRecordDelete");
                setSelected([...selected]);
                setDeleteCsvData(true);
              }}
              disabled={
                selected?.length === 0 ||
                importCsvListData?.data?.list?.length === 0
              }
            >
              Delete
            </Button>

            <Button
              className="BtnGreen"
              variant="contained"
              onClick={() => {
                // setImportTypeDiloag(true);
                // downloadPDF();
              }}
            >
              How To Import
            </Button>
            <Select className={classes.rsSelectMenulist}>
              {importType.map((name) => (
                <MenuItem
                  key={name.value}
                  value={name.label}
                  onClick={(e, value) => {
                    setDocLink(name?.link);
                    setImportTypeDiloag(true);
                  }}
                >
                  {name?.label}
                </MenuItem>
              ))}
              <MenuItem
                className={classes.MenuListDownload}
                onClick={() => {
                  downloadPDF();
                }}
              >
                {/* <Button
                  variant="outlined"
                  onClick={() => {
                    downloadPDF();
                  }}
                > */}
                Download Demo CSV
                {/* </Button> */}
              </MenuItem>
            </Select>
            <Button
              className={clsx("BtnGreen", classes.rsButtonAddIcon)}
              variant="contained"
              // className={}
              style={{ marginRight: "20px" }}
              // variant="outlined"
              startIcon={
                <PrimaryIcon
                  icon={AddIcon}
                  color="white"
                  width="16px"
                  height="16px"
                />
              }
              onClick={() => {
                setOpenImportCsvPopup(true);
              }}
            >
              Import Patients
            </Button>
          </Grid>
        </Grid>
        <Grid
          className={clsx(
            "common-table",
            width <= 1200 ? classes.managePageHMob : classes.managePageH
          )}
        >
          <TableContainer>
            <Table stickyHeader>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell>
                    <Box>
                      {importCsvListData?.data?.list?.length > 0 && (
                        <FormControlLabel
                          className={classes.labelWhiteSpaceNW}
                          checked={
                            importCsvListData?.data?.list?.length > 0 &&
                            selected?.length ===
                              importCsvListData?.data?.list?.length
                          }
                          onChange={handleChangeAction}
                          control={<Checkbox color="primary" />}
                        />
                      )}
                      FIRST NAME
                    </Box>
                  </TableCell>
                  <TableCell>LAST NAME</TableCell>
                  <TableCell>DOB</TableCell>
                  <TableCell>EXTRA DATA</TableCell>
                  <TableCell>ACTION</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                {importCsvListData?.loading ? (
                  <TableCellLoader cells={5} />
                ) : importCsvListData?.data?.list?.length > 0 ? (
                  importCsvListData?.data?.list?.map((item, i) => {
                    const isSelected = (id) => selected?.indexOf(id) !== -1;
                    const isItemSelected = isSelected(item?.tp_id);
                    const labelId = `enhanced-table-checkbox-${i}`;
                    return (
                      <TableRow key={item?.tp_id}>
                        <TableCell
                          semiBold
                          onClick={(event) =>
                            handleClickTickAction(event, item?.tp_id)
                          }
                        >
                          <Box>
                            <FormControlLabel
                              className={classes.labelWhiteSpaceNW}
                              checked={isItemSelected}
                              control={<Checkbox color="primary" />}
                              label=""
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                            {item?.tp_other_detail?.first_name}
                          </Box>
                        </TableCell>
                        <TableCell semiBold>
                          {item?.tp_other_detail?.last_name
                            ? item?.tp_other_detail?.last_name
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.tp_other_detail?.dob
                            ? moment(
                                new Date(item?.tp_other_detail?.dob)
                              ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell>
                          <HtmlTooltipMain
                            title="Extra data"
                            className="hoverAlign"
                          >
                            <IconButton
                              onClick={() => {
                                setExtraDataDiloag(true);
                                setExtraData(item?.tp_extra_data);
                              }}
                            >
                              <PrimaryIcon
                                color="primary"
                                width="20px"
                                icon={Info}
                                cursor="pointer"
                              />
                            </IconButton>
                          </HtmlTooltipMain>
                        </TableCell>
                        <TableCell>
                          <Box
                            display={"flex"}
                            fontWeight="300"
                            alignItems={"center"}
                          >
                            <HtmlTooltipMain
                              title="Create Patient"
                              className="hoverAlign"
                            >
                              <IconButton
                                onClick={() => {
                                  setOpenCreatePatientPopup(true);
                                  setCreateNewPatientFromCSV(item);
                                }}
                              >
                                <PrimaryIcon
                                  color="primary"
                                  width="20px"
                                  icon={EditIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                            <HtmlTooltipMain
                              title="Delete"
                              className="hoverAlign"
                            >
                              <IconButton
                                onClick={() => {
                                  setDeleteRecordActionType(
                                    "singleRecordDelete"
                                  );
                                  setDeleteId(item?.tp_id);
                                  setDeleteCsvData(true);
                                }}
                              >
                                <PrimaryIcon
                                  width="20px"
                                  icon={DeleteIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableEmptyState />
                )}
                {importCsvListData?.data?.list?.length !=
                  importCsvListData?.data?.filterd_record && (
                  <TableLoadMore setRef={setTarget} />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <ImportExtraDataDiloag
        open={extraDataDiloag}
        setOpen={setExtraDataDiloag}
        extraData={extraData}
      />
      <ImportCsvPatientDialog
        open={openImportCsvPopup}
        setOpen={setOpenImportCsvPopup}
        getImportCsvListAction={getImportCsvListAction}
        subscriptionDialog={subscriptionDialog}
        setSubscriptionDialog={setSubscriptionDialog}
        loginUserDetail={loginUserDetail}
      />
      <ConfirmationDialog
        open={deleteCsvData}
        setOpen={setDeleteCsvData}
        title="Are you sure?"
        body="You wan't be able to undo this!"
        handleSubmit={handleDeleteCsvList}
        actionBtnTitle="Yes Delete It!!"
        loading={deleteMultipleAndSingleCsvData?.loading}
      />
      <PatientCreateDialog
        open={openCreatePatientPopup}
        setOpen={setOpenCreatePatientPopup}
        callBackOnSubmit={onSuccessOfSubmitPatientForm}
        createNewPatientFromCSV={createNewPatientFromCSV}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscriptionDialog}
      />
      <ImportTypeDialog
        link={docLink}
        open={importTypeDiloag}
        setOpen={setImportTypeDiloag}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  importCsvListData: state.patient.importCsvListData,
  deleteMultipleAndSingleCsvData: state.patient.deleteMultipleAndSingleCsvData,
});

const mapDispatchToProps = (dispatch) => ({
  getImportCsvListAction: (payload) =>
    dispatch({ type: START_GET_IMPORT_CSV_LIST, payload }),
  deleteCsvAction: (payload) =>
    dispatch({ type: START_DELETE_MULTIPLE_AND_SINGLE_CSV, payload }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportCsvMain);
